var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 1012.49997",
    height: 1350,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8f2f223b63"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 102.792969 203.792969 L 706.992188 203.792969 L 706.992188 807.992188 L 102.792969 807.992188 Z M 102.792969 203.792969 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f2f223b63)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#cac9c9",
    d: "M 404.996094 203.792969 C 238.027344 203.792969 102.792969 339.027344 102.792969 505.996094 C 102.792969 672.964844 238.027344 808.203125 404.996094 808.203125 C 571.964844 808.203125 707.203125 672.964844 707.203125 505.996094 C 707.203125 339.027344 571.964844 203.792969 404.996094 203.792969 Z M 404.996094 747.761719 C 271.421875 747.761719 163.234375 639.574219 163.234375 505.996094 C 163.234375 372.421875 271.421875 264.234375 404.996094 264.234375 C 538.574219 264.234375 646.761719 372.421875 646.761719 505.996094 C 646.761719 639.574219 538.574219 747.761719 404.996094 747.761719 Z M 404.996094 747.761719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRingIcon);
export default __webpack_public_path__ + "static/media/ring_icon.237c7f3e08bbd45610a79d17c23b96a6.svg";
export { ForwardRef as ReactComponent };